import { ContactContext, PagePath } from '@spa/components/organisms/contact/model/context/contact-context'
import { OrderContext } from '@spa/components/pages/order/model/context/order-context'

export class ContactOnOrderPageContext implements ContactContext {
  static buildFromOrderContext(
    orderContext: OrderContext
  ): ContactOnOrderPageContext {
    return new ContactOnOrderPageContext(
      {
        editContact: orderContext.path.editContact,
        addContact: orderContext.path.addContact,
      },
      orderContext.title
    )
  }

  private constructor(
    public readonly path: PagePath,
    public readonly title: string
  ) {}
}
